"use client"
import { ITrack } from '@models'
import React from 'react'
import styles from './playlist.module.scss'
import Icon from '@components/icon'
import { faClock, faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import Image from 'next/image'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import he from 'dayjs/locale/he'
import { OPEN_SPOTIFY } from '@lib/helpers'
dayjs.extend(relativeTime).locale(he)

const getDuration = (ms: number) => {
    const minutes = Math.floor(ms / 60000)
    const seconds = ((ms % 60000) / 1000).toFixed(0)
    return `${minutes}:${parseInt(seconds) < 10 ? '0' : ''}${seconds}`
}
const getTimeAgo = (date: string) => {
    return dayjs(date).fromNow()
}

export default function PlaylistDesktop({tracks}: {tracks: ITrack[]}) {
    return (
        <table className={`${styles.container} ${styles.desktop}`}>
            <thead>
                <tr>
                    <th>#</th>
                    <th className={styles.right}>שיר</th>
                    <th className={styles.right}>אלבום</th>
                    <th><Icon icon={faClock} /></th>
                </tr>
            </thead>
            <tbody>
                {
                    tracks.map((track, index) => (
                        <tr key={track.id}>
                            <td>{index + 1}</td>
                            <td className={styles.right}>
                                <div className={styles.track}>
                                    {
                                        track.image && <Image loading='lazy' src={track.image} width={50} height={50} alt={track.name} />
                                    }
                                    <div className={styles.width}>
                                        <span>{track.name}</span>
                                        <div className={styles.artists}>
                                            {
                                                track.artists.map((artist, index) => (
                                                    <span key={index}>{artist}</span>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className={styles.right}>
                                <div className={styles.width}>
                                    <span>{track.album}</span>
                                    <div className={`${styles.go} click`} onClick={() => OPEN_SPOTIFY(track.href)}>
                                        <Icon icon={faPlayCircle} />
                                        האזנה ב-Spotify
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className={styles.duration}>
                                    <span>{getDuration(track.duration_ms)}</span>
                                    <span>{getTimeAgo(track.added_at)}</span>
                                </div>
                            </td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
    )
}